
import { getShippingPrice } from '~~/helpers/cart/getTotalPrices';

export const useShippingCost = () => {

  const { cart } = useCartExtended();
  const { order } = useUserOrderExtended();
  const i18n = useI18n();

  const shippingCost = computed(
    () => {

      return getShippingPrice(cart.value || order.value);
    
    });

  const shippingCostLabel = computed(() => shippingCost.value
    ? i18n.n(
      shippingCost.value,
      'currency',
    )
    : i18n.t('Free'),
  );

  return {
    shippingCostLabel,
    shippingCost,
  };

};
